export const theme = {
  fonts: {
    heading: '"Oswald", sans-serif',
    body: '"Source Sans Pro", sans-serif',
  },
  colors: {
    primary: '#333333',
    secondary: '#666666',
    accent: '#0073aa',
    background: '#ffffff',
    border: '#dddddd',
    text: '#333333',
    textLight: '#666666',
    white: '#ffffff',
    black: '#000000',
  },
  breakpoints: {
    mobile: '600px',
    tablet: '800px',
    desktop: '1000px',
    wide: '1200px',
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '4rem',
  },
  shadows: {
    text: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    card: '0 2px 8px rgba(0, 0, 0, 0.1)',
    hover: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
};

export type Theme = typeof theme;
